import { type GameApi } from 'urban-challenger-sdk';

import { QrCodeDisplay } from './qr-code-display';
import { TeamCodeDisplay } from './team-code-display';

export function init(
    teamCodeQrCodes: NodeListOf<HTMLElement>,
    teamCodeDisplays: NodeListOf<HTMLElement>,
    sdk: GameApi
): void {
    if (teamCodeQrCodes.length) {
        teamCodeQrCodes.forEach((q) => {
            new QrCodeDisplay(q).hide().connect(sdk);
        });
    }
    if (teamCodeDisplays.length) {
        teamCodeDisplays.forEach((d) => {
            new TeamCodeDisplay(d).hide().connect(sdk);
        });
    }
}
